import { useEffect } from 'react';
import { SINGLE_TENANT } from '@/config/singleTenant';
import { useTenant } from '@/contexts/TenantContext';

/** Applies IITH document brand attribute for single-tenant / campus mode. */
export default function IithBrandRoot({ children }) {
  const { platformConfig, pinned } = useTenant();
  const campus = SINGLE_TENANT || platformConfig?.single_tenant_mode || pinned;

  useEffect(() => {
    const root = document.documentElement;
    if (campus) root.setAttribute('data-brand', 'iith');
    else root.removeAttribute('data-brand');
    return () => root.removeAttribute('data-brand');
  }, [campus]);

  return children;
}
